import iso from "iso-3166-1";

export const getFlagFromAlpha3 = (countryCode: string) => {
	const alpha2 = iso.whereAlpha3(countryCode).alpha2;
	const flag = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${alpha2}.svg`;
	return flag;
};

export const getFlagFromCountryName = (countryName: string) => {
	let countryNameToUse =
		countryName === "ALAND ISLANDS"
			? "ÅLAND ISLANDS"
			: countryName === "REUNION"
				? "Réunion"
				: countryName === "SOUTH KOREA"
					? "Republic of Korea"
					: countryName === "NORTH KOREA"
						? "Democratic People's Republic of Korea"
						: countryName === "ST BARTHELEMY"
							? "Saint Barthélemy"
							: countryName === "St Marino"
								? "San Marino"
								: countryName === "ST MARTIN"
									? "Saint Martin"
									: countryName === "ST PIERRE AND MIQUELON"
										? "Saint Pierre and Miquelon"
										: countryName === "TANZANIA"
											? "United Republic of Tanzania"
											: countryName === "UNITED KINGDOM"
												? "United Kingdom of Great Britain and Northern Ireland"
												: countryName === "UNITED STATES"
													? "United States of America"
													: countryName === "VIETNAM"
														? "Viet Nam"
														: countryName;

	if (countryNameToUse === "VATICAN CITY") {
		return "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFUIdAm0189U5Hl2WNzhLzBbAhO0tclqZo_A&s";
	}
	const country = iso.whereCountry(countryNameToUse);
	if (!country) {
		return null;
	}
	const flag = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.alpha2}.svg`;
	return flag;
};
